export default {
  rentalPrice: "RentalsPrice",
  AddRentals: "AddRentalsPrice",
  editRentals: "EditRentalsPrice"
};
